<template>
    <ol class="breadcrumb" v-if="crumbs.length > min">
        <li v-for="(crumb, i) in crumbs">
            <router-link v-if="i < crumbs.length - 1" :to="{name: crumb.name, params: $route.params}">{{crumb.meta.breadcrumb}}</router-link>
            <span v-else="">{{crumb.meta.breadcrumb}}</span>
        </li>
    </ol>
</template>

<script>
    export default {
        name: 'breadcrumbs',
        props: {
            min: {
                default: 0,
            }
        },
        data() {
            return {
                crumbs: [],
            }
        },
        watch: {
            $route(to, from)
            {
                this.refresh();
            }
        },
        methods: {
            refresh() {
                this.crumbs = [];
                if(this.$route.matched.length > 0)
                {
                    for(let i = 0; i < this.$route.matched.length; i++)
                    {
                        let route = this.$route.matched[i];

                        if(route.meta !== undefined && route.meta.breadcrumb !== undefined)
                        {
                            this.crumbs.push(route);
                        }
                    }
                }
            },
        },
        mounted() {
            this.refresh();
        }
    }
</script>